import { reduceDataPath } from "../../../utility";
import { ArstActionContextmenuAction } from "../interface";

/**
 * Get the correct targetDataPath to update
 *
 * @param action - Context menu action
 */
export function arst_resolveTargetPath<T>(action: ArstActionContextmenuAction<T>): string;
/**
 * Get the correct targetDataPath to update
 *
 * @param dataPath - Input targetDataPath
 */
export function arst_resolveTargetPath(dataPath: string): string;

export function arst_resolveTargetPath<T>(inp: string | ArstActionContextmenuAction<T>): string {
  // Standard string
  if (typeof inp === "string") {
    const pathParts = inp.split("/").filter(Boolean);
    // Check for dataValues/groups
    if (["dataValues", "groups"].includes(pathParts[pathParts.length - 2])) {
      pathParts.splice(-2, 2);
    }
    return `/${pathParts.join("/")}`;
  }
  // Context menu action
  else {
    return "targetType" in inp.cellValue &&
      ["group", "dataDriven"].includes(inp.cellValue.targetType)
      ? reduceDataPath(inp.cellValue.dataPath, 2)
      : inp.cellValue.dataPath;
  }
}
